import { t } from "@/i18n";
import moment from "moment";

export function getErrorMessageObj(message) {
  return {
    title: t("OrderPage[\"Error\"]"),
    message,
    type: "error",
    duration: 8000,
  }
}

export function getDraftObjFroApi(draftObj) {
  let { 
    patientId, 
    paymentMethod, 
    labProcessingFee, 
    contactInfo, 
    sendNotification, 
    orderItems,
    draftName,
    deliveryMethod,
    sendDate,
    plannedOrderList,
    isDbsVersion
  } = draftObj;
  // convert to integer if is string
  let patientIdInt = Number.isInteger(patientId) ? patientId : parseInt(patientId, 10);

  let delivery_method = {
    blood: deliveryMethod.blood,
    non_blood: deliveryMethod.nonBlood,
    dry_ice: deliveryMethod.dryIce
  }
  let result = {
    patientId: patientIdInt,
    chargeMethod: paymentMethod,
    lab_processing_fee: labProcessingFee.toString(),
    email: contactInfo.email,
    send_email: sendNotification.email,
    cell_phone: contactInfo.phone,
    send_text: sendNotification.text,
    orderItems,
    draftName: draftName,
    delivery_method,
    bloodKitDeliveryMethod: deliveryMethod.blood,
    nonBloodKitDeliveryMethod: deliveryMethod.nonBlood,
    dryIceKitDeliveryMethod: deliveryMethod.dryIce,
    send_date: sendDate,
    planned_order_list: plannedOrderList,
    dbs: isDbsVersion,
  }
  return result;
}

// disable checkout for rupa clinic account 1007150 login
// start from 02/01/2024
export function isDisableCheckoutForRupa(userInfo) {
  if (!userInfo) {
    return false;
  }
  let { isClinic, old_clinic_id } = userInfo;
  let isRupaClinicAccount = old_clinic_id === 1007150 && isClinic;
  let startHideDate = moment(new Date("Feb 01, 2024 12:00 AM")).local();
  let isHide = moment().local().isSameOrAfter(startHideDate);
  return isRupaClinicAccount && isHide;
}